import { useState } from "react";
import { post, remove } from "../config/axiosConfig.ts";
import { useToast } from "@chakra-ui/react";

export const useBookingTickets = (setOrderConfirmed) => {
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const toast = useToast();

  const closeSubmit = async (id: string) => {
    try {
      await remove(`event-order-ms/ticket/remove/order/${id}`, {});
      setOrderConfirmed(null);
    } catch (error) {}
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await post(
        "event-order-ms/ticket/create/order-info",
        data
      );

      if (response.code === 200) {
        toast({
          title: "Tickets successfully reserved.",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      } else {
        toast({
          position: "top",
          title: "Something went wrong!",
          status: "error",
          isClosable: true,
        });
        closeSubmit(data.eventTicketOrderId);

      }

      setUrl(response?.body);
    } catch (error) {
      toast({
        title: "Check tickets quantity",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
      setOrderConfirmed(null);
    } finally {
      setLoading(false);
    }
  };
  return { onSubmit, closeSubmit, loading, url, setUrl };
};
